module.exports = __webpack_public_path__ + "static/media/loading.baeaf0c7.gif";